import { useEffect, useMemo } from 'react';

export const useBodyChild = <T extends keyof HTMLElementTagNameMap>(tagName: T) => {
  const el = useMemo(() => document.createElement(tagName), [tagName]);

  useEffect(() => {
    document.body.appendChild(el);

    return () => void document.body.removeChild(el);
  }, [el]);

  return el;
};
